unit UFeiertagList;

interface

uses
  system.Contnrs, UFeiertagModel, UEssentialHelper, Js;

type
  TFeiertagList = class(TObjectList)
  private
    FOnPropertyChanged: TCallback;
    function GetItem(i: Integer): TFeiertagModel;
    procedure PropertyChanged;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetValues(json: string); overload;
    procedure SetOnPropertyChanged(const Value: TCallback);
  public
    function GetItemByDatum(datum: TDateTime): TFeiertagModel;
    procedure Add(item: TFeiertagModel);
    procedure GetAll(url: string; personalNr: string; jahr: Integer);
    property Items[i: Integer]: TFeiertagModel read GetItem;
    property OnPropertyChanged: TCallback read FOnPropertyChanged write SetOnPropertyChanged;
  end;

implementation

uses
  System.SysUtils, WebLib.JSON, WebLib.REST;

{ TFeiertagList }

procedure TFeiertagList.Add(item: TFeiertagModel);
begin
  inherited Add(item);
end;

procedure TFeiertagList.GetAll(url, personalNr: string; jahr: Integer);
var obj: TJsonObject;
    helper: string;
    client: TRestClient;
  procedure Response(Sender: TObject; aResponse: string);
  var jso: TJsObject;
  begin
    jso:=TJsJson.parseObject(aResponse);
    if jso['value']<>nil then
      Self.SetValues(string(jso['value']));
    Self.PropertyChanged;
  end;
begin
  obj:=TJsonObject.Create;
  obj.AddPair('PersonalNr',personalNr);
  obj.AddPair('Jahr',IntToStr(jahr));
  helper:=obj.ToString;
  obj:=TJsonObject.Create;
  obj.AddPair('value',helper);
  client:=TRestClient.Create(nil);
  client.OnResponse:=Response;
  client.HttpsPost(url+'/FeiertagService/GetAll','application/json',obj.ToString);
  client.Free;
  obj.Free;
end;

function TFeiertagList.GetItem(i: Integer): TFeiertagModel;
begin
  Result:=inherited GetItem(i) as TFeiertagModel;
end;

function TFeiertagList.GetItemByDatum(datum: TDateTime): TFeiertagModel;
var i: Integer;
    found: Boolean;
begin
  found:=false;
  i:=0;
  while not found and (i<Self.Count) do
    if Trunc(Self.Items[i].Datum)=Trunc(datum) then
      found:=true
    else
      Inc(i);
  if found then
    Result:=Self.Items[i]
  else
    Result:=nil;
end;

procedure TFeiertagList.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TFeiertagList.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TFeiertagList.SetValues(json: string);
var obj: TJsObject;
begin
  obj:=TJsJson.parseObject(json);
  SetValues(obj);
end;

procedure TFeiertagList.SetValues(obj: TJsObject);
var i, count: Integer;
begin
  Self.Clear;
  if obj['Count']<>nil then begin
    count:=StrToInt(string(obj['Count']));
    for i:=0 to count-1 do
      if obj['Item'+IntToStr(i)]<>nil then
        Self.Add(TFeiertagModel.Create(string(obj['Item'+IntToStr(i)])));
  end;
end;

end.
